<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <b-tab :title="$t('config.productCategory.title')">
                                <product-category></product-category>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';
    import ProductCategory from '@/views/config/product/ProductCategoryList';

    export default {
        name: "ProductConfig",
        components: {
            'b-tabs': bTabs,
            'b-tab': bTab,
            ProductCategory
        }
    }
</script>

<style scoped>

</style>